import { FunctionComponent } from 'react';
import { Badge } from '../Badge/Badge';

export interface ReportStatusColor {
  bg: string;
  text: string;
}

export interface ReportStatusBadgeProps {
  status: string;
  colors: Record<string, ReportStatusColor>;
}

export const ReportStatusBadge: FunctionComponent<ReportStatusBadgeProps> = ({
  status,
  colors,
}) => {
  const color = colors[status];

  return <Badge label={status} bgColor={color?.bg} textColor={color?.text} />;
};
